<template>
  <div class="container mt-5 mb-5">
    <div class="row justify-content-center align-items-center">
      <div class="col-md-6 col-sm-12 col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="text-center mt-5 mb-3">
              <img :src="isDarkMode ? require('@/assets/logo-nav.webp') : require('@/assets/logo-nav-dark.webp')"
              class="img-fluid mt-3" width="250" />
            </div>
            <h5 class="text-center">Login</h5>
            <div class="mb-3">
              <label for="username" class="form-label text-start">Usuario</label>
              <input type="text" class="form-control" placeholder="user@mail.com" id="username" v-model="username"
                required>
            </div>
            <div class="mb-3">
              <label for="password" class="form-label text-start">Password</label>
              <input type="password" class="form-control" placeholder="******" id="password" v-model="password"
                @keyup.enter="login" required>
            </div>

            <vs-button  color="rgb(59,222,200)" gradient block @click="login">Iniciar sesión</vs-button>
            <hr>
            <p class="text-center smallText mt-3">
              <router-link to="/forgot">¿Olvidaste tu password?</router-link>
            </p>
            <!-- <p class="text-center smallText mt-3">
              Don't you have an account? <router-link class="text-link" to="/register">Sign up</router-link>
            </p> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { auth } from '../fb';
  import { signInWithEmailAndPassword } from "firebase/auth";
  import axios from 'axios';
  var config = require("@/config/api.json");
  const API = config.api;
  export default {
    name: 'Index',
    data() {
      return {
        username: null,
        password: null,
        isDarkMode: false,
      };
    },
    async created() {
      this.isDarkMode = localStorage.getItem('light');
      if (this.isDarkMode !== null) {
        localStorage.setItem('light', true);
        document.body.classList.toggle('light-mode', true);
      } else {
        document.body.classList.toggle('light-mode', true);
        localStorage.setItem('light', true);
      }

      try {
        await this.checkAuthState();
      } catch (error) {
        console.error("Error en mounted: ", error);
        // Manejar el error, por ejemplo, redirigir al usuario, mostrar un mensaje, etc.
      }
    },
    methods: {
      async login() {
        if (this.username.trim() === '') {
          this.notify('error', 'Error: El campo usuario está vacío');
          return;
        }
        if (!this.vEmail(this.username)) {
          this.notify('error', 'Error: Correo electrónico inválido');
          return;
        }

        if (this.password.trim() === '') {
          this.notify('error', 'Error: El campo contraseña está vacío');
          return;
        }
        signInWithEmailAndPassword(auth, this.username, this.password)
          .then(async (userCredential) => {
            const targetRoute = '/home';
            const user = userCredential.user;
            try {
              const response = await axios.get(`${API}/verificar_medico/${user.uid}`);
              if (response.data.status === 'success') {
                const medicoId = response.data.id;
                let ipAddress = 'IP desconocida'; // Valor por defecto
                try {
                  // Llama a un servicio para obtener la IP pública
                  const ipResponse = await axios.get('https://api.ipify.org?format=json');
                  ipAddress = ipResponse.data.ip;
                } catch (ipError) {
                  console.error("Error al obtener la dirección IP:", ipError);
                  // Opcional: notificar al usuario o simplemente registrar el error
                  // this.notify('warning', 'No se pudo obtener la IP para auditoría.');
                }
                const auditMessage = `Login exitoso: ${ipAddress}`;
                await this.callAudit(medicoId, "LOGIN", "personal_medico", medicoId, auditMessage);
              }
            } catch (error) {
              console.error('Error al verificar médico o auditar:', error);
              this.notify('error', 'Error al verificar médico.');
              return;
            }

            if (this.$route.path !== targetRoute) {
              this.$router.push({ name: 'Home' });
            }
          })
          .catch((error) => {
            this.notify('error', `Error: ${error.code}`);
            this.username = null;
            this.password = null;
          })
          .finally(() => {
            this.closeLoading();
          });
      }
    }
  }
</script>